module.exports = __webpack_public_path__ + "media/notification_2.36195605.wav";